var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl20 pr20",class:_vm.type == 'affirm' ? ['button','affirm'] : ['button','back'],on:{"click":_vm.emitEvent}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }